'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hasElementEnteredViewport = function hasElementEnteredViewport(element) {
  return element.getBoundingClientRect().top <= window.innerHeight;
};

exports.hasElementEnteredViewport = hasElementEnteredViewport;
//# sourceMappingURL=utils.js.map
